import React from 'react';

import { LabelDescription, LabelWrapper, Wrapper } from './styles';

type Props = {
  label: string;
  description?: string;
};

const FormLabel = ({ label, description }: Props): JSX.Element => (
  <Wrapper>
    <LabelWrapper>{label}</LabelWrapper>
    {description && <LabelDescription>{description}</LabelDescription>}
  </Wrapper>
);

export default FormLabel;
